import { Component, Input, OnChanges, OnInit } from '@angular/core';

import { UIProgressBullet } from './progress-bullet.interface';

@Component({
	selector: 'ui-progress-bullets',
	templateUrl: './progress-bullets.component.html',
	styleUrls: ['./progress-bullets.component.less'],
})
export class UIProgressBulletsComponent implements OnInit, OnChanges {
	@Input() bullets: UIProgressBullet[];

	progress_percentage = 0;

	ngOnInit() {
		this.progress_percentage = this.getProgressPercentage();
	}

	ngOnChanges() {
		this.progress_percentage = this.getProgressPercentage();
	}

	getProgressPercentage(): number {
		if (!this.bullets || !this.bullets.length) {
			return 0;
		}

		const current_bullet = this.bullets.find((bullet) => bullet.state === 'current');

		if (!current_bullet) {
			return 0;
		}

		const current_index = this.bullets.findIndex((bullet) => bullet.id === current_bullet.id);

		if (current_index === 0) {
			return 0;
		}

		return (current_index / (this.bullets.length - 1)) * 100;
	}
}
